exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bgcolor {\n    background-color: #f0f0f7;\n}\n\n.iconscale {\n    position: relative;\n    -webkit-transition: 0.3s ease;\n    transition: 0.3s ease;\n}\n\n.iconscale {\n    -webkit-transform: scale(1.5, 1.5);\n            transform: scale(1.5, 1.5);\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main